<template>
  <div class="w-100">
    <b-row v-if="isVrmaAsTab">
      <b-col>
        <div class="d-flex justify-content-end mb-2">
          <add-vrma-component
            :poNumber="poId"
          />
        </div>
      </b-col>
    </b-row>
    <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_VENDOR_RETURNS)"
        :canDelete="checkClaim(CAN_DELETE_VENDOR_RETURNS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
        :navigationField="'partNumber'"
      />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import AddVrmaComponent from '../add';
import { GRID_ID } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridSettings,
    GridComponent,
    AddVrmaComponent
  },
  props: {
    vendorrmaId: {
      type:  [Number, String],
      default: 0,
    },
    showAllGridRows: {
      type: [Boolean],
      default: false,
    },
    poId: {
      type: [Number, String],
      default: 0
    },
    poLineId: {
      type: [Number, String],
      default: 0
    },
    isVrmaAsTab: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedRowItemId: 0,
    gridId: GRID_ID.VENDORRMAS_LINES,
    fields: gridFields,
    checkedRowItemIds: [],
  }),
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('vendorrmas', ['vendorrmaLinesById']),
    ...mapState('vendorrmas', ['vrmaLinesByFilter']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    vendorrmaLines() {
      return this.vendorrmaLinesById(this.vendorrmaId);
    },
    itemData() {
      const vrmaLine = this.isVrmaAsTab ? this.vrmaLinesByFilter : this.vendorrmaLines;
      if (vrmaLine == undefined || !vrmaLine.length) return [];
      return vrmaLine.map((vendorrmaLines) => ({ ...vendorrmaLines, selected: vendorrmaLines.id === this.selectedRowItemId }));
    },
  },
  methods: {
    ...mapActions('vendorrmas', [
      'getLinesById',
      'onDeleteVRMALine',
      'getLinesByFilter'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapMutations('vendorrmas', ['setLinesByFilter']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
    onEdit(data) {
      this.$emit('showEdit', data);
    },
    async onDelete(data) {
      const deleteConfirmed = await this.openConfirmBox({ message: `Are you sure you want to delete this RMA Line for Part ${data.partNumber}?` });
      if (deleteConfirmed) {
        const result = await this.onDeleteVRMALine({
          vrmaId: data.vendorRMAId,
          vrmaLineId: data.id
        });
        this.$snotify.success('Deleted RMA Line', 'Vendor RMA');
        this.$emit('showDelete', data);
      }
    },
    async generateFilter() {
      let filters = `{`;
      let flagForCall = false;

      if (this.poLineId > 0) {
        flagForCall = true;
        filters += `POLineId: ${this.poLineId}`
      }

      filters += `}`;

      // If there's a filter, then call the API, else, make it empty
      if (flagForCall) {
        await this.getLinesByFilter(filters);
      } else {
        this.setLinesByFilter([]);
      }
    }
  },
  watch: {
    vendorrmaId() {
      if(this.vendorrmaId) {
        this.getLinesById(this.vendorrmaId);
      }
    },
    vendorrmaLines() {
      //This function sets the first row as the selected row
      this.selectedRowItemId = this.setSelectedRowId(this.vendorrmaLines, this.selectedRowItemId);
    },
    selectedRowItemId(newVal) {
      const selectedRow = this.vendorrmaLines.find(vendorrmaLine => vendorrmaLine.id === newVal);
      this.$emit('selectedVendorRmaLine', selectedRow);
    },
    checkedRowItemIds() {
      this.$emit('updateCheckedRowItemIds', this.checkedRowItemIds);
    },
    poLineId() {
      this.generateFilter();
    },
  },
  mounted() {
    if(this.vendorrmaId){
      this.getLinesById(this.vendorrmaId);
    }
  },
};
</script>